
import { useState } from "react";
import "./Work_flow_manager.css";
import { Tasks } from "./Task";
import { Schedule_manager } from "./Schedule_manager";
import {Run_history} from "./Run_history"


export function Work_flow_manager() {
    const [activeSection, setActiveSection] = useState("Tasks");

    const navItems = [
        "Overview",
        "Tasks",
        "Schedules",
        "Runs",
        "Settings"
    ];

    return (
        <div className="wfm-layout">
            {/* Navigation */}
            <nav className="wfm-nav">
                <h2>Workflow Manager</h2>

                {navItems.map((item) => (
                    <button
                        key={item}
                        className={
                            activeSection === item ? "active" : ""
                        }
                        onClick={() => setActiveSection(item)}
                    >
                        {item === "Runs" ? "Runs & History" : item}
                    </button>
                ))}
            </nav>

            {/* Dynamic content */}
            <main className="wfm-content">
                <header className="wfm-header">
                    <h1>
                        {activeSection === "Runs"
                            ? "Runs & History"
                            : activeSection}
                    </h1>
                </header>

                <section className="wfm-section">
                    {activeSection === "Overview" && (
                        <div>Overview section</div>
                    )}

                    {activeSection === "Tasks" && (
                            <Tasks />
                    )}

                    {activeSection === "Schedules" && (
                        <Schedule_manager/>
                    )}

                    {activeSection === "Runs" && (
                        <Run_history/>
                   
                    )}

                    {activeSection === "Settings" && (
                        <div>Settings section</div>
                    )}
                </section>
            </main>
        </div>
    );
}
